export default {
    // Global styles
    ':root': {
        '--scrollbar-width': '16px'
    },

    // Media queries
    '@media screen and (min-width: 992px)': {
        '.search-suggestions': {
            boxShadow: 'var(--chakra-colors-searchBarShadow)'
        }
    },

    '@media screen and (max-width: 991px)': {
        '.basket-icon': {
            zIndex: 'auto !important'
        }
    },

    /*** Fixing new IOS version 26 ***/
    body: {
        height: '100%'
    },

    html: {
        height: '100%'
    },
    /*** Fixing new IOS version 26 ***/

    '.chakra-skeleton': {
        '--skeleton-start-color': 'var(--chakra-colors-gray-425)',
        '--skeleton-end-color': 'var(--chakra-colors-gray-750)'
    },

    '.footer-philanthropy-wrapper, .utility-banner-wrapper': {
        borderImageSource:
            'linear-gradient(90deg, var(--chakra-colors-gray-450) 0%, var(--chakra-colors-gray-850) 100%)',
        borderImageSlice: 1
    },

    '.hide-element': {
        display: 'none !important'
    },

    // The site footer is outside the PLP component tree. Keep its space reserved,
    // but do not paint it while the product grid or PLP content is still settling.
    'body:has(.sf-product-list-page[data-grid-loading="true"]) .footer-container': {
        visibility: 'hidden',
        pointerEvents: 'none'
    },

    // Accessibility styles
    'html.un-assistive .utility-banner-wrapper a:focus, html.un-assistive .utility-banner-wrapper a:hover, .disableUsableNetAssistive:focus, .disableUsableNetAssistive:hover':
        {
            color: 'var(--chakra-colors-white) !important',
            border: '2px dashed !important',
            borderColor: 'var(--chakra-colors-white)'
        },
    'html.un-assistive .utility-banner-svgs': {
        marginRight: '39px'
    },
    '.category-trigger-wrapper button': {
        bottom: '14px',
        right: '-8px',
        left: '0px',
        marginRight: 0
    },
    '.categories-stack': {
        gap: '20px'
    },
    'html.un-assistive .assistive-wrapper': {
        position: 'absolute !important',
        padding: '0px !important',
        backgroundColor: 'transparent !important'
    },
    // Swiper styles
    '.swiper': {
        '--swiper-navigation-size': '42px',
        '--swiper-navigation-top-offset': '0',
        '--swiper-navigation-sides-offset': 'initial',
        '--swiper-pagination-color': '#4D3159',
        '--swiper-pagination-bullet-size': '6px',
        '--swiper-pagination-bullet-horizontal-gap': '5px',
        '--swiper-pagination-top': 'initial',
        '--swiper-pagination-bottom': '40px',

        '.swiper-button-next, .swiper-button-prev': {
            background:
                'white url(https://res.cloudinary.com/kendra-scott/image/upload/q_auto/UIImages/images/chevron-right-icon.svg) no-repeat center',
            backgroundSize: '15px',
            transform: 'none',
            borderRadius: '4px',
            margin: 0,
            width: 'var(--swiper-navigation-size)',

            '&:before, &:after': {
                content: "''",
                display: 'none'
            },

            '&:hover': {
                backgroundColor: 'var(--chakra-colors-gray-50)'
            }
        },

        '.swiper-button-next.swiper-button-lock, .swiper-button-prev.swiper-button-lock': {
            display: 'none !important'
        },

        '.swiper-button-next': {
            right: '15px',
            '@media screen and (min-width: 992px)': {
                right: '60px'
            }
        },

        '.swiper-button-prev': {
            right: '62px',
            left: 'initial',
            transform: 'rotate(180deg)',
            '@media screen and (min-width: 992px)': {
                right: '107px'
            }
        }
    },

    'iframe[id^="iframe-notification"]': {
        zIndex: '1100 !important'
    },

    '.accessibility-placeholder': {
        minWidth: '112px'
    },

    '.un-assistive .accessibility-placeholder': {
        minWidth: '89px'
    },

    '.tile-wrapper .tile-box:hover ~ .quick-add-parent, .tile-wrapper .quick-add-parent:hover': {
        '.quick-add-wrapper': {
            opacity: '1',
            pointerEvents: 'auto',
            transition: '0.3s ease'
        },
        '.sizes-available': {
            opacity: '1',
            pointerEvents: 'auto',
            height: 'fit-content',
            transition: '0.3s ease'
        }
    },

    '.tile-box:hover': {
        '.wishlist-wrapper': {
            opacity: '1',
            transition: '0.3s ease'
        }
    },

    '.disabled-swatch::after': {
        content: '" "',
        borderLeft: '1px solid',
        color: 'gray.600',
        transform: 'rotate(54deg)',
        height: '72px',
        position: 'absolute',
        left: '50%'
    },

    '.product-stack[data-invalid="true"] select': {
        borderColor: 'red.400 !important',
        '&:hover': {
            borderColor: 'red.400 !important',
            boxShadow: '0px 3px var(--chakra-colors-red-400) !important'
        }
    },
    '[data-invalid="false"]': {
        'select:hover': {
            ':focus:not([data-focus-visible-added]):not( [data-focus-visible-disabled] )': {
                borderColor: 'purple.300 !important',
                boxShadow: '0px 3px var(--chakra-colors-purple-300) !important'
            }
        }
    },
    'html[data-brand="yellowrose"] .backToShop, html[data-brand="yellowrose"] .glControls input': {
        backgroundColor: 'black.300 !important',
        color: 'white !important',
        '&:hover': {
            backgroundColor: 'black.50 !important'
        }
    },
    '.glMainContent li': {
        color: 'black !important',
        fontFamily: 'body !important'
    },
    '.glTitle, .glPopupContent h1, .glMainContent .caption': {
        color: 'black !important'
    },
    '.changeShipping': {
        textUnderlineOffset: '4px'
    },
    '.glMainContent select': {
        color: 'black',
        borderColor: 'black'
    },
    '.chakra-ui-light': {
        top: '0px !important' // used to keep the background visible once country selector is opened after scrolling down.
    },
    '.chakra-modal__content-container': {
        zIndex: '10000000000 !important' // all drawers should be above 3rd party widgets
    },
    '.usabilla_live_button_container': {
        zIndex: '1000000 !important'
    },
    '.chakra-alert__title': {
        fontWeight: 400,
        fontSize: '16px',
        color: 'black',
        fontFamily: 'heading'
    },
    '.chakra-toast__inner': {
        minWidth: 'fit-content !important',
        maxWidth: 'fit-content !important'
    },
    '.chakra-toast__inner button': {
        top: 'unset !important'
    },
    '.chakra-alert[data-status="error"]': {
        backgroundColor: 'red.20'
    },
    '.block-scroll': {
        touchAction: 'none'
    },

    '.promo-sticky-active': {
        position: 'sticky !important',
        top: '60px !important',
        zIndex: 2
    },
    '.product-view-compact[data-is-promo="true"]': {
        '.chakra-select__icon-wrapper': {
            top: '28px !important'
        }
    },

    '.adyen-checkout__spinner--medium': {
        height: '25px !important',
        width: '25px !important'
    },

    '#iadvize-container iframe': {
        zIndex: '3 !important'
    }
}
